// extracted by mini-css-extract-plugin
export var changeIcon = "_47-4";
export var container = "_47-0";
export var divider = "_47-7";
export var externalLinkIcon = "_47-1";
export var green = "_47-5";
export var helpCircleIcon = "_47-3";
export var iconButton = "_47-2";
export var red = "_47-6";